<template>
  <div class="home">
    <v-carousel
      hide-delimiters
      hide-arrows
      :left-control-icon="false"
      :right-control-icon="false"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <!-- <div class="container">
      <backtohauptspeise></backtohauptspeise>
    </div> -->
    <v-card>
      <v-card-title class="display-3">
        Udon
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
      >
        <template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
// import Backtohauptspeise from './Backtohauptspeise.vue';
export default {
  // components: { Backtohauptspeise },
  name: 'Nudeln',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/gebrateneudonseitlich.jpg'),
        },
        {
          src: require('../assets/images/gebrateneudonmithintergrund.jpg'),
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: '201',
          speise: 'Gebratene Udon mit Hühnerfleisch und Gemüse',
          allergene: '(A, C, F, N)',
          preis: '10,10 €',
        },
        {
          nummer: '202',
          speise: 'Gebratene Udon mit Rindfleisch und Gemüse',
          allergene: '(A, C, F, N)',
          preis: '10,90 €',
        },
        {
          nummer: '203',
          speise: 'Gebratene Udon mit Meeresfrüchte oder Garnelen und Gemüse',
          allergene: '(A, C, F, R, N)',
          preis: '12,20 €',
        },
        {
          nummer: '204',
          speise: 'Gebratene Udon mit Gemüse',
          allergene: '(A, C, F, N)',
          preis: '10,40 €',
        },
        {
          nummer: '205',
          speise: 'Gebratene Udon mit knuspriger Ente und Gemüse',
          allergene: '(A, C, F, N)',
          preis: '13,50 €',
        },
        {
          nummer: '206',
          speise: 'Gebratene Udon mit knusprigem Huhn und Gemüse',
          allergene: '(A, C, F, N)',
          preis: '12,80 €',
        },
        {
          nummer: '207',
          speise: 'Gebratene Udon mit Tofu und Gemüse',
          allergene: '(A, C, F, P, N)',
          preis: '11,90 €',
        },
        {
          nummer: '208',
          speise: 'Gebratene Udon mit Lachssteak und Gemüse',
          allergene: '(A, C, D, F, N)',
          preis: '13,90 €',
        },
        // {
        //   nummer: '209',
        //   speise: 'Gebratene Udon mit faschiertem und Gemüse',
        //   allergene: '(A, C, F, N)',
        //   preis: '10,00 €',
        // },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
